import { render, staticRenderFns } from "./testinglist.vue?vue&type=template&id=5ee30e2c&scoped=true&"
import script from "./testinglist.vue?vue&type=script&lang=js&"
export * from "./testinglist.vue?vue&type=script&lang=js&"
import style0 from "./testinglist.vue?vue&type=style&index=0&id=5ee30e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee30e2c",
  null
  
)

export default component.exports